type ViewportPosition = 'above' | 'below' | 'intersecting';

export const getElementViewportPosition = (
    child: HTMLElement,
    container: HTMLElement,
): ViewportPosition => {
    // Get the bounding rectangle of the container (visible area) and the child element.
    const containerRect = container.getBoundingClientRect();
    const childRect = child.getBoundingClientRect();

    // If the bottom of the child is above the top of the container,
    // then the child is completely "above" the visible area.
    if (childRect.bottom < containerRect.top) {
        return 'above';
    }

    // If the top of the child is below the bottom of the container,
    // then the child is completely "below" the visible area.
    if (childRect.top > containerRect.bottom) {
        return 'below';
    }

    // Otherwise, some portion of the child is within the container's view.
    return 'intersecting';
};
